/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import * as React from 'react';
import TermsOfService from './TermsOfService';
import CopyRight from './CopyRight';
import { IldsFooterProps } from '../lds-footer.data';

export const FooterLegal: React.FC<IldsFooterProps> = ({
    termsOfUse,
    privacyPolicy,
    resources,
    config,
    privacyTitle,
    termsTitle,
    onClick
}) => {
    return (
        <div className={config.footerInfo ? 'footerLegalWithInfo' : 'footerLegal'}>
            <TermsOfService
                termsOfUse={termsOfUse}
                privacyPolicy={privacyPolicy}
                config={config}
                resources={resources}
                termsTitle={termsTitle}
                privacyTitle={privacyTitle}
                onClick={onClick}
            />
            <CopyRight resources={resources} />
        </div>
    );
};
